(function () {
  if (typeof window === 'undefined') return;

  /* ---------- Scroll-based reveal ---------- */
  var reveal = function () {
    var wh = window.innerHeight;
    var els = document.querySelectorAll('[data-vk-reveal]:not(.in)');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < wh - 40) els[i].classList.add('in');
    }
  };
  [80, 300, 700, 1500].forEach(function (ms) { setTimeout(reveal, ms); });
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
  }
  window.addEventListener('scroll', reveal, { passive: true });
  window.addEventListener('resize', reveal);
  document.addEventListener('DOMContentLoaded', reveal);

  /* ---------- Sticky header blur on scroll ---------- */
  var onHeaderScroll = function () {
    var hdr = document.querySelector('[data-vk-header]');
    if (!hdr) return;
    if (window.scrollY > 80) hdr.classList.add('scrolled');
    else hdr.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onHeaderScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', onHeaderScroll);
  onHeaderScroll();

  /* ---------- Mobile menu toggle ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-vk-menu-toggle]');
    if (toggle) {
      var hdr = document.querySelector('[data-vk-header]');
      if (!hdr) return;
      var nav = hdr.querySelector('.hdr-nav');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // Tap/click mega nav item on mobile to expand
    var megaBtn = e.target.closest('.vk-hdr .nav-item.has-mega > .nav-btn');
    if (megaBtn && window.matchMedia('(max-width: 1100px)').matches) {
      var item = megaBtn.closest('.nav-item');
      if (item && megaBtn.getAttribute('href') === '#') {
        e.preventDefault();
      }
      if (item) item.classList.toggle('open');
    }
  });
})();
